/**
 * emailDeliveryRecipientDndApi
 *
 * DASH-EMAIL-010: client for the real, read-only RECIPIENT-grain DND
 * Dashboard API (`GET /api/email-delivery/dashboard/recipient-dnd`).
 *
 * Sourced from email_dnd_current_state -- the GHL "Email DND Required"
 * bidirectional sync current-state projection (EMAIL-DND-IMPL-001). This
 * is a STRICTLY SEPARATE state machine from emailDeliveryRecipientHealthApi.js's
 * hygiene grain (sendgrid_hygiene_recipient_state) -- this module must
 * never be used to fetch or substitute for a hygiene metric, and that
 * client must never be used for DND. See email_dnd_dashboard_service.py's
 * own docstring for the canonical-source rule this pairing enforces.
 *
 * Wraps the SAME shared `api` axios instance every other real-backed War
 * Room surface already uses -- no second HTTP stack, no collection name
 * ever appears here or in any caller. Auth (Bearer token) and account
 * scoping (X-Account-ID header) are attached automatically by that
 * instance's own request interceptor; this module never accepts or
 * forwards a caller-supplied account/tenant/location id -- this endpoint
 * takes no query parameters at all.
 *
 * Response shape: {dnd_flagged_count, dnd_cleared_count,
 * sync_needs_attention_count, evidence_status: "available"|"unavailable",
 * generated_at}. Never the raw document, a recipient email, a GHL
 * contact/location id, `targets[]`, or `revision`.
 */
import { api } from "./api";

export async function getEmailDeliveryRecipientDnd() {
  const res = await api.get("/email-delivery/dashboard/recipient-dnd");
  return res.data;
}

export default getEmailDeliveryRecipientDnd;
